import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import {Link} from 'gatsby';
import ImageTyped from './ImageTyped';
import Worth from './Worth';

const Container = styled.div`
    display: flex;
    flex-wrap : wrap;
    justify-content : center;
    margin-top:-125px;
    padding-bottom: 30px;


    
    & h4{
		font-family : 'Cormorant',serif;
        font-size: 25px;
		font-weight : 500;
		text-align: center;
		margin-bottom: 10px;
		padding-top:20px;	
	}
	
	& h5{
	    font-weight : 700;
	}

	& h5, & p{
		width: 90%;
		font-family: 'Raleway', sans-serif;
		font-size: 15px;
		text-align: center;
		margin: auto;
		line-height: 20px;
	}

	& p > a{
		width: fit-content;
		font-size: 16px;
		text-align: center;
		padding-top: 20px;
		display : block;
		margin:auto;
		color:  #FD9D87;
		position: relative;
	}
	& p > a:hover{
		color: #000;
	}
	& p > a:before{
		content: '';
		position: absolute;
		width: 100%;
		height: 1px;
		bottom: -2px;
		left: 0;
		background-color: grey;
		visibility: hidden;
		-webkit-transform: scaleX(0);
		transform: scaleX(0);
		-webkit-transition:all 0.3s ease-in-out 0s;
		transition: all 0.3s ease-in-out 0s;
	}
		
	& p > a:hover:before{
		visibility: visible;
		-webkit-transform: scaleX(1);
		transform: scaleX(1);
	}
    
   
`;




class WorthList extends Component {
    render() {
        const {
            worth
        } = this.props;

        const worths = worth.edges[0].node.worths;

        return (
            <Container >
                {
                    worths.map((block, i) => {
                        return (<Worth block={block}/>)
                    })

                }

            </Container>
        )
    }
}


export default WorthList;